enum SocialNetwork {
    INSTAGRAM = 'INSTAGRAM',
    FACEBOOK = 'FACEBOOK',
    LINKED_IN = 'LINKED_IN',
    TIKTOK = 'TIKTOK',
    GOOGLE_CALENDAR = 'GOOGLE_CALENDAR',
}

export default SocialNetwork